import React from 'react';
import { benefits } from '../../data/benefits';
import { photos } from '../../data/site';
import { Container } from '../ui/Container';
import { Reveal } from '../ui/Reveal';
import { SectionTitle } from '../ui/SectionTitle';
export function Benefits() {
  return <section id="why-bates" aria-labelledby="why-title" className="bg-white py-20 lg:py-28" data-id="element-35" data-mp="2l7z69sjvmuoj">
      <Container className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-36" data-mp="2g9e61t4mkb03">
        <div className="lg:col-span-5" data-id="element-37" data-mp="3dyh9quoiiy2h">
          <div className="lg:sticky lg:top-28" data-id="element-38" data-mp="38zwihkr8noq6">
            <img src={photos.mentorMoment} alt="An adult holding a young Bates Taekwondo student in a warm moment at the school" className="aspect-[4/3] w-full rounded object-cover sm:aspect-[16/10] lg:aspect-[4/5]" style={{
            objectPosition: '50% 30%'
          }} loading="lazy" data-id="element-39" data-mp="3917lvjgruugr" />
            <p className="mt-4 text-sm text-muted" data-id="element-40" data-mp="1ok2rmt8029fy">Encouragement is part of every class at Bates.</p>
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-41" data-mp="3a0xb2gempzxi">
          <Reveal data-id="element-42" data-mp="39z46d6nktps5">
            <SectionTitle id="why-title" data-id="element-43" data-mp="3f09zh5l5ff27">What practice builds, one class at a time</SectionTitle>
            <p className="text-pretty mt-6 max-w-[36rem] text-[1.05rem] leading-relaxed text-muted" data-id="element-44" data-mp="310irblhbcsw4">
              Taekwondo gives students a clear goal, a coach who notices effort, and plenty of chances to try again.
              Here’s what that looks like on the mat.
            </p>
          </Reveal>

          <dl className="mt-12 grid gap-x-12 sm:grid-cols-2" data-id="element-45" data-mp="2w1fnu5gzeuq9">
            {benefits.map((benefit, i) => <Reveal key={benefit.label} delay={i * 0.04} className="border-t border-line pb-10 pt-6" data-id="element-46" data-mp="2hct3tqgetesp" data-mpi={i}>
                <dt data-id="element-47" data-mp="2mb34ggkwl7lp">
                  <span className="block text-sm font-semibold uppercase tracking-[0.12em] text-brand" data-id="element-48" data-mp="2mcnwnzjqwege">{benefit.label}</span>
                  <span className="mt-2 block font-display text-[1.85rem] font-bold uppercase leading-none" data-id="element-49" data-mp="28cmw6l7e791g">{benefit.title}</span>
                </dt>
                <dd className="text-pretty mt-4 text-[15px] leading-relaxed text-muted" data-id="element-50" data-mp="iv99xdph9muf">{benefit.body}</dd>
              </Reveal>)}
          </dl>

          <p className="border-t border-line pt-6 text-[15px] font-medium" data-id="element-51" data-mp="e1wk5092ba03">
            Every student moves at their own pace. There’s no single timeline for progress, only the next step.
          </p>
        </div>
      </Container>
    </section>;
}